import { api, endpoints } from "api/api";
import { BaseApiPaging } from "api/types";
import { AxiosPromise } from "axios";
import { PlaceTagFormValues } from "pages/PlaceTags/PlaceTagForm/PlaceTagForm";

const create = (data: PlaceTagFormValues): AxiosPromise => {
  return api.post(endpoints.PLACETAGS.CREATE(), data);
};

const fetch = (
  skip: number,
  take: number,
  searchPhrase: string,
  filter: string,
  orderBy: string
): AxiosPromise<BaseApiPaging<PlaceTagApi>> => {
  return api.get<BaseApiPaging<PlaceTagApi>>(endpoints.PLACETAGS.GET(skip, take, searchPhrase, filter, orderBy));
};

const fetchById = (placetagId: number): AxiosPromise<PlaceTagApi> => {
  return api.get<PlaceTagApi>(endpoints.PLACETAGS.GET_BY_ID(placetagId));
};

const update = (placetagId: number, data: PlaceTagFormValues): AxiosPromise<PlaceTagApi> => {
  return api.put<PlaceTagApi>(endpoints.PLACETAGS.UPDATE(placetagId), data);
};

const deletePlace = (placetagId: number): Promise<void> => {
  return api.delete(endpoints.PLACETAGS.DELETE(placetagId));
};

export const placeTagsApi = {
  create,
  fetch,
  fetchById,
  update,
  delete: deletePlace,
};

export interface PlaceTagApi {
  id: number;
  name: string;
}
